import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';
import {Component} from '@angular/core';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';
import {Subscription} from 'rxjs/Subscription';
import {TimerObservable} from 'rxjs/observable/TimerObservable';

@Component({
  selector: 'map-reports',
  styleUrls: ['./reports.map.css', '../reports.css'],
  templateUrl: './reports.map.component.html'
})

export class ReportsMapComponent {
  public locations = {};
  private locationsSubscription: Subscription;
  public isLoadingMap: boolean = false;

  public center = {lat: 0, lon: 0};
  private refreshPeriod: number = 10000;

  constructor(private http: HttpClient, private auth: AuthenticationService, private urlHelper: UrlHelper) {
    //
  }

  private getLocations(n: number) {
    if (n === 0) this.isLoadingMap = true;

    this.http.get(`${this.urlHelper.getPrefix()}/locations`).subscribe((res: any) => {
      let cLat = 0;
      let cLon = 0;

      res.data.forEach(location => {
        this.locations[location.id] = location.attributes;

        cLat += parseFloat(location.attributes.latitude);
        cLon += parseFloat(location.attributes.longitude);
      });

      cLat /= res.data.length;
      cLon /= res.data.length;

      this.center.lat = cLat;
      this.center.lon = cLon;
    }, (err) => {
      this.isLoadingMap = false;
    }, () => {
      this.isLoadingMap = false;
    });
  }

  ngOnInit() {
    this.locationsSubscription = TimerObservable.create(0, this.refreshPeriod).subscribe((n) => {
      this.getLocations(n);
    });
  }

  ngOnDestroy() {
    if (this.locationsSubscription) {
      this.locationsSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/map/reports.map.component.ts